"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var qr_code_content_provider_service_1 = require("../../../shared/services/api/qr-code-content-provider.service");
var QRCodeSettingsComponent = /** @class */ (function (_super) {
    __extends(QRCodeSettingsComponent, _super);
    function QRCodeSettingsComponent(communicationService, qrCodeContentProviderService) {
        var _this = _super.call(this, communicationService) || this;
        _this.communicationService = communicationService;
        _this.qrCodeContentProviderService = qrCodeContentProviderService;
        _this.qrOptions = {
            color: {}
        };
        _this.isReady = false;
        return _this;
    }
    Object.defineProperty(QRCodeSettingsComponent.prototype, "state", {
        set: function (state) {
            this._state = state;
        },
        enumerable: true,
        configurable: true
    });
    QRCodeSettingsComponent.prototype.ngOnInit = function () {
        this.generationOptions$ = this.qrCodeContentProviderService.qrGenerationOptions(this.category);
        this.propertyKey = this._state['propertyKey'];
        this.qrOptions = this._state['qrOptions'] || this.qrOptions;
        this.isReady = true;
    };
    QRCodeSettingsComponent.prototype.onPropertyKeyChange = function (propertyKey) {
        this.propertyKey = propertyKey;
        this.changeCommunicationSettings();
    };
    QRCodeSettingsComponent.prototype.onDarkColorChange = function (color) {
        this.qrOptions.color.dark = color;
        this.changeCommunicationSettings();
    };
    QRCodeSettingsComponent.prototype.onLightColorChange = function (color) {
        this.qrOptions.color.light = color;
        this.changeCommunicationSettings();
    };
    QRCodeSettingsComponent.prototype.onScaleChange = function (matSliderChange) {
        this.qrOptions.scale = matSliderChange.value;
        this.changeCommunicationSettings();
    };
    QRCodeSettingsComponent.prototype.changeCommunicationSettings = function () {
        var data = {
            bindings: {},
            state: this.getState(),
            fields: {}
        };
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, data));
    };
    QRCodeSettingsComponent.prototype.getState = function () {
        return {
            qrOptions: this.qrOptions,
            propertyKey: this.propertyKey,
            tooltipSettings: this._tooltipSettings ? this._tooltipSettings.toJsonString() : undefined,
        };
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], QRCodeSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], QRCodeSettingsComponent.prototype, "controlLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], QRCodeSettingsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], QRCodeSettingsComponent.prototype, "formType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], QRCodeSettingsComponent.prototype, "state", null);
    QRCodeSettingsComponent = __decorate([
        core_1.Component({
            
            selector: "ejustice-qr-code-settings",
            template: require('./qr-code.settings.component.html')
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<ejustice-qr-code-settings\n                    [category]=\"%{category}\"\n                    [state]=\"%{state}\"\n                    [languages]=\"%{languages}\"\n                    [controlLabel]=\"%{controlLabel}\"\n                    [currentLanguageId]=\"%{currentLanguageId}\"\n                    [formType]=\"%{formType}\">\n                </ejustice-qr-code-settings>",
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
            qr_code_content_provider_service_1.QRCodeContentProviderService])
    ], QRCodeSettingsComponent);
    return QRCodeSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.QRCodeSettingsComponent = QRCodeSettingsComponent;
//# sourceMappingURL=qr-code.settings.component.js.map